import React, { useState, useEffect, Fragment } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { timesheetApi } from "../../services";
import properties from "../../config/environmentProperties";
import UserAttendanceDetails from "./userAttendence";
import { SplitButton } from "primereact/splitbutton";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { attendanceApi } from "../../services";
import { useLocation } from "react-router-dom";

export default function TeamAttendance() {
  const { search } = useLocation();
  const urlActions = new URLSearchParams(search).get("action");
  const [viewEmpList, setViewEmpList] = useState([true]);
  const [employeeList, setEmployeeList] = useState([]);
  const imgPath = properties.currentEnvironment.docPath + "images/";
  const [viewEmpAttendance, setViewEmpAttendance] = useState(false);
  const [clickedViewUser, setClickedViewUser] = useState([]);
  const [clickedIndex, setClickedIndex] = useState('');
  const [filterDialog, setFilterDialog] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [filterObj, setFilterObj] = useState('');
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (urlActions === "app") {
      const urlActionsType = new URLSearchParams(search).get("type");
      urlActionsType === 0 ? setClickedIndex(0) : setClickedIndex(1);
      setViewEmpAttendance(true);
      setViewEmpList(false);
    } else {
      setViewEmpList(true);
      setViewEmpAttendance(false);
    }
    getEmpList();
  }, []);

  const attendancTeameRefresh = () => {
    setViewEmpAttendance(false);
    setViewEmpList(true);
  }

  const getEmpList = () => {
    attendanceApi.getAllTeamAttendance().then((resp) => {
      try {
        setEmployeeList(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };

  const imageBodyTemplate = (item) => {
    return (
      <div className="flex align-items-center gap-2">
        {item?.photo === "" || item?.photo === null ? (
          <span className="photo-span" style={{ height: "35px", width: "35px", borderRadius: "50%", border: "2px solid #d7e9ff", display: "flex", alignItems: 'center', justifyContent: 'center', fontSize: "18px", fontWeight: "600", color: "#1369b6", padding: '5px', paddingTop: '1px' }}>
            {item.firstName.toUpperCase().substr(0, 1)}
            {item.lastName.toUpperCase().substr(0, 1)}
          </span>
        ) : (
          <img style={{ height: "40px", width: "40px", borderRadius: "50%", border: "3px solid #d7e9ff", Top: "16px", bottom: "16px", left: "16px" }} src={imgPath + item?.photo || ""} alt="" />
        )}
        <div>{item.firstName + " " + item.lastName}</div>
      </div>
    );
  };

  const viewClickedUserAttendance = (rowData, type) => {
    type === 0 ? setClickedIndex(0) : setClickedIndex(1);
    setClickedViewUser(rowData);
    setViewEmpAttendance(true);
    setViewEmpList(false);
  };

  const buttonTemplate = (rowData) => {
    const items = [
      {
        label: "RECORDED ATTENDANCE",
        icon: "pi pi-history",
        command: () => {
          viewClickedUserAttendance(rowData, 0);
        },
      },
    ];

    return (
      <Button label="Review" onClick={(e) => viewClickedUserAttendance(rowData, 1)} tooltip="Recorded Attendence" tooltipOptions={{ position: "left" }} icon="pi pi-eye" />
      // <SplitButton className="p-button-rounded mr-2 mb-2 ess-split-btn" label="Review" onClick={(e) => viewClickedUserAttendance(rowData, 1)} tooltip="" tooltipOptions={{ position: "left", mouseTrack: true, mouseTrackTop: 15 }} icon="pi pi-eye" model={items}></SplitButton>
    );
  };

  const designationBodyTemplate = (item) => {
    return item?.Designation?.title;
  };

  const searchUser = (data) => {
    setShowButton(true);
    var dataObj = {};
    if (data.ecn !== "") {
      dataObj.ecn = data.ecn;
    }
    if (data.firstName !== "") {
      dataObj.firstName = data.firstName;
    }
    if (data.lastName !== "") {
      dataObj.lastName = data.lastName;
    }
    if (data.email !== "") {
      dataObj.email = data.email;
    }
    if (data.phone !== "") {
      dataObj.phone = data.phone;
    }
    let isClear = true;
    for (let v of Object.keys(data)) {
      if (data[v] != undefined && data[v] != '') {
        isClear = false
      }
    }
    if (isClear) { setShowMessage(false) }

    try {
      setFilterObj(dataObj);
      timesheetApi.filterTeamData(dataObj).then(
        (resp) => {
          if (resp.status === 200) {
            setEmployeeList(resp.data.data);
            setShowButton(false);
            searchForm.resetForm();
            setFilterDialog(false);
          }
        },
        (error) => {
          setUsers();
          setShowButton(true);
        }
      );
    } catch (error) { }
  };

  const searchForm = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      ecn: "",
      phone: "",
      designation: "",
    },
    validate: (data) => {
      let errors = {};
      return errors;
    },
    onSubmit: (data) => {
      setShowMessage(true);
      searchUser(data);
      searchForm.resetForm();
    },
  });

  const isFormFieldValid = (name) =>
    !!(searchForm.touched[name] && searchForm.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{searchForm.errors[name]}</small>
      )
    );
  };

  const tableHeader = () => {
    return (
      <Fragment>
        <div className="grid">
          <div className="col-6">
            <span className="heading">
              <h1 className="p-0">Team Members</h1>
            </span>
          </div>
          <div className="col-6 mt-3 mb-2">
            <span className="heading">
              <div className="heading-actions">
                <Button icon="pi pi-replay" className="p-button-rounded p-button-help p-button-text" aria-label="Replay" onClick={() => getEmpList()} />
                <Button icon="pi pi-filter" className="p-button-rounded p-button-help p-button-text" aria-label="Filter" onClick={() => setFilterDialog(true)} />
              </div>
            </span>
          </div>
        </div>
      </Fragment>
    );
  };


  const SearchForm = () => {
    return (
      <Fragment>
        <Dialog header="User Filter" visible={filterDialog} position="right" modal style={{ width: '500px' }}
          onHide={() => setFilterDialog(false)}
          draggable={false} resizable={false}>
          <form onSubmit={searchForm.handleSubmit}>
            <div className="grid p-fluid">
              <div className="col-6 field">
                <label htmlFor="firstName" className={classNames({ "p-error": isFormFieldValid("firstName"), })}>First Name</label>
                <span className="p-float-label">
                  <InputText name="firstName" value={searchForm.values.firstName} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label htmlFor="lastName" className={classNames({ "p-error": isFormFieldValid("lastName"), })}>Last Name</label>
                <span className="p-float-label">
                  <InputText name="lastName" value={searchForm.values.lastName} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label htmlFor="ecn" className={classNames({ "p-error": isFormFieldValid("ecn"), })}>ECN</label>
                <span className="p-float-label">
                  <InputText name="ecn" value={searchForm.values.ecn} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label className={classNames({ "p-error": isFormFieldValid("email") })}>Email Address</label>
                <span className="p-float-label">
                  <InputText name="email" value={searchForm.values.email} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label className={classNames({ "p-error": isFormFieldValid("phone") })}>Phone</label>
                <span className="p-float-label">
                  <InputText name="phone" value={searchForm.values.phone} onChange={searchForm.handleChange} />
                </span>
              </div>
            </div>
            <div className="col-12">
              <Button type="submit" icon="pi pi-search" label="Search" className="p-button-rounded filter_btn" />
            </div>
          </form>
        </Dialog>
      </Fragment>
    );
  };
  const rowClass = (rowData) => {
    let row = rowData.Attendances.map((item) => { return item.status });
    if (row.includes(3)) {
      return {
        'row-accessories-attendance': row
      }
    }
  }

  return (
    <React.Fragment>
      {viewEmpList && (
        <>
          {SearchForm()}
          <div className="datatable-style-demo">
            <DataTable value={employeeList} header={tableHeader} paginator responsiveLayout="scroll" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]} rowClassName={rowClass}>
              <Column field="ecn" header="ECN"></Column>
              <Column field="firstName" header="Name" body={imageBodyTemplate} sortable className="initCap"></Column>
              <Column field="email" header="Email Address"></Column>
              <Column field="phone" header=" Mobile no."></Column>
              <Column header="Designation" body={designationBodyTemplate}></Column>
              <Column field="status" header="Action" body={buttonTemplate} style={{ textAlign: "center", width: "50px" }}></Column>
            </DataTable>
          </div>
        </>
      )}
      {viewEmpAttendance && (
        <UserAttendanceDetails
          userData={clickedViewUser}
          selectedIndex={clickedIndex}
          attendanceRefresh={attendancTeameRefresh}
        />
      )}
    </React.Fragment>
  );
}
